module.exports = "<p>\n  page-not-found works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /dist/src/app/ui/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/ui/page-not-found/page-not-found.component.html
// module chunks = main